/**
 * Get the display label for a matter
 * @param {Object} matter - The matter object
 * @param {String} groupName - Optional group name
 * @param {String} id - Optional matter ID
 * @returns {String} The formatted matter label
 */
export const getMatterLabel = (matter, groupName, id) => {
  if (matter?.label) {
    return matter.label;
  } else if (matter?.name) {
    return matter.name;
  } else if (id && id.startsWith('label_')) {
    return id.substring(6);
  } else if (id && id.startsWith('name_')) {
    return id.substring(5);
  } else if (groupName) {
    return groupName.replace(' (Not Billed)', '').replace('Services', '').trim();
  } else if (id) {
    return 'Matter ' + id;
  }
  return 'Unknown Matter';
};